import { render, staticRenderFns } from "./notification_page.vue?vue&type=template&id=30cc5138&scoped=true&"
import script from "./notification_page.vue?vue&type=script&lang=js&"
export * from "./notification_page.vue?vue&type=script&lang=js&"
import style0 from "./notification_page.vue?vue&type=style&index=0&id=30cc5138&prod&scoped=true&lang=css&"
import style1 from "./notification_page.vue?vue&type=style&index=1&id=30cc5138&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cc5138",
  null
  
)

export default component.exports